var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-items',_vm._l((_vm.items),function(item,index){return _c('v-btn',{key:index,attrs:{"to":item.link,"text":""}},[_vm._v(_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }